import { Fragment } from "react/jsx-runtime";
import { productKeys, productLabelKey } from "../../chart-helpers/chart-data";
import { useConfig } from "../../containers/ConfigContext";
import { downloadDataIntoCSV, getUrlParam } from "../../lib/helper";
import {
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export interface CommonCardListProps {
  title?: string;
}

export default function DetailsCardList(props: CommonCardListProps) {
  const mobile = getUrlParam("mobile");
  const { title } = props;
  const { reviews } = useConfig();

  const products = [...productKeys, "none"].map((k) => ({
    name: productLabelKey[k] || k,
    comments: (reviews?.data || [])
      .filter((a) => a.answer?.[`promooffer_${k}_key_1`])
      .map((c) => ({
        comment: c.promooffer_textbox,
        date_time: moment(c.answer.date_time).format("YYYY-MM-DD hh:mm:ss"),
        name: c.filter_name,
        store: c.filter_store,
      })),
  }));

  const getFlatCsvData = (products: any[]) => {
    const obj: any = {};
    return (products || [])
      .reduce((p, c) => {
        return p.concat(
          c.comments.map((d: any) => {
            const v = `${obj[c.name] ? "" : `"${c.name}"`},"${d.comment}",${d.date_time
              },"${d.name}","${d.store}"`;
            obj[c.name] = true;
            return v;
          }),
        );
      }, [])
      .join("\n");
  };

  return (
    <Stack spacing={2}>
      {title && (
        <Paper elevation={mobile ? 0 : 2} className="padding-small">
          <Typography variant={"h6"} textAlign={"center"}>
            {title}
            {!mobile && (
              <IconButton
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  downloadDataIntoCSV(
                    `product,comment,date_time,name,store_type\n${getFlatCsvData(
                      products,
                    )}`,
                    `PromoOffer-${new Date().getTime()}`,
                  );
                }}
              >
                <CloudDownloadIcon />
              </IconButton>
            )}
          </Typography>
        </Paper>
      )}
      <Paper elevation={0} className="flex-1">
        <Grid container spacing={2}>
          {(products || []).map((product) => (
            <Grid item xs={12} md={3} key={`${product.name}`}>
              <Paper sx={{ height: "100%" }} elevation={mobile ? 0 : 2}>
                <Stack spacing={2} p={1} height={"100%"}>
                  <Typography>
                    <b>{product.name}</b>
                  </Typography>
                  <Divider />
                  <List
                    sx={{ minHeight: 150, maxHeight: 300, overflowY: "auto" }}
                  >
                    {(product.comments || []).map(({ comment, name }, i) => (
                      <Fragment key={`${comment}${name}${i}`}>
                        <ListItem>
                          <ListItemText
                            primary={comment}
                            primaryTypographyProps={{
                              sx: {
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              },
                            }}
                          />
                        </ListItem>
                      </Fragment>
                    ))}
                  </List>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Stack>
  );
}
